import { Layout } from "./layout";

type Props = {
	children: React.ReactNode;
};

export const CardLayout = ({ children }: Props) => {
	return <Layout className="rounded-lg border border-zinc-300 px-4 py-2 sm:px-8 sm:py-5">{children}</Layout>;
};
